module.exports = __webpack_public_path__ + "media/images/top/pap/common/img_point02-6f4863e9a534cb0d0037956ef152e01b.png";